// Shared components
import { FilterByDropdown } from '@components/filters';
import { Button } from '@/components/ui/button';
import { PlusIcon } from '@components/icons';

// Hooks
import { useTranslation } from '@hooks/useTranslation';

// Types
import type { EventsToolbarProps } from '../../types';

export function EventsToolbar({
  categories,
  onNewOrder,
  className,
}: EventsToolbarProps) {
  const {t} = useTranslation();

  return (
    <div className={className}>
      <div className="flex flex-wrap items-center gap-3">
        <FilterByDropdown categories={categories} />

        <Button onClick={onNewOrder}>
          <PlusIcon className="size-5" aria-hidden="true" />
          {t('toolbar.new_order')}
        </Button>
      </div>
    </div>
  );
}
